(function () {
  'use strict';

  function initVitrin(section) {
    if (!section || section.dataset.atVitrinReady === '1') return;
    section.dataset.atVitrinReady = '1';

    var rail = section.querySelector('.at-vitrin__mosaic');
    var prevBtn = section.querySelector('[data-at-vitrin-prev]');
    var nextBtn = section.querySelector('[data-at-vitrin-next]');
    if (!rail || !prevBtn || !nextBtn) return;

    var items = Array.from(rail.children);
    if (!items.length) return;

    var isMobile = function () {
      return window.matchMedia('(max-width: 560px)').matches;
    };

    var cardStep = function () {
      var first = items[0];
      if (!first) return 0;
      var firstRect = first.getBoundingClientRect();
      var gap = parseFloat(window.getComputedStyle(rail).columnGap || window.getComputedStyle(rail).gap || '0') || 0;
      return firstRect.width + gap;
    };

    var indexFromScroll = function () {
      var step = cardStep();
      if (!step) return 0;
      return Math.max(0, Math.min(items.length - 1, Math.round(rail.scrollLeft / step)));
    };

    var goToIndex = function (idx, behavior) {
      if (!isMobile()) return;
      var step = cardStep();
      if (!step) return;
      var clamped = Math.max(0, Math.min(items.length - 1, idx));
      rail.scrollTo({ left: clamped * step, behavior: behavior || 'smooth' });
    };

    var updateButtons = function () {
      if (!isMobile()) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      var idx = indexFromScroll();
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= items.length - 1;
    };

    prevBtn.addEventListener('click', function () {
      goToIndex(indexFromScroll() - 1, 'smooth');
    });

    nextBtn.addEventListener('click', function () {
      goToIndex(indexFromScroll() + 1, 'smooth');
    });

    var settleTimer = 0;
    rail.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) return;
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          goToIndex(indexFromScroll(), 'smooth');
          updateButtons();
        }, 110);
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        updateButtons();
      },
      { passive: true }
    );

    updateButtons();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.at-vitrin').forEach(initVitrin);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  /* Fallback delegated nav (in case section re-renders after listeners) */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-at-vitrin-prev], [data-at-vitrin-next]') : null;
    if (!btn) return;
    var section = btn.closest('.at-vitrin');
    var rail = section && section.querySelector('.at-vitrin__mosaic');
    var first = rail && rail.querySelector('.at-vitrin__cell, .at-vitrin__video');
    if (!rail || !first) return;
    var gap = parseFloat(window.getComputedStyle(rail).columnGap || window.getComputedStyle(rail).gap || '0') || 0;
    var step = first.getBoundingClientRect().width + gap;
    var dir = btn.hasAttribute('data-at-vitrin-next') ? 1 : -1;
    rail.scrollTo({ left: Math.max(0, rail.scrollLeft + step * dir), behavior: 'smooth' });
  });
})();
